<style>
    #retailerlogo {
        /* border: 1px solid #ddd;
        border-radius: 4px; */
        padding: 5px;
        width: 150px;
    }

    #retailerlogo:hover {
        box-shadow: 0 0 2px 1px rgba(0, 140, 186, 0.5);
    }

    #jumbotron1 {
        background-size: cover;
        background-repeat: no-repeat;
    }

    .map-container-5 {
        overflow: hidden;
        padding-bottom: 56.25%;
        position: relative;
        height: 0;
    }

    .map-container-5 iframe {
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        position: absolute;
    }

    #up_button {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    #categoryimage {
        /* border: 1px solid #ddd;
        border-radius: 4px; */
        padding: 5px;
        width: 50px;
    }

    .card-image {
        /* width: auto;
        height: auto; */
        max-width: 150px;
        height: fit-content;
        max-height: 300px !important;
        object-fit: cover;
        object-position: center;
    }


    .avatar {
        vertical-align: middle;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        margin-top: 20px;
        -webkit-box-shadow: 0 0 0 3px #fff, 0 0 0 4px #999, 0 2px 5px 4px rgba(0, 0, 0, .2);
        -moz-box-shadow: 0 0 0 3px #fff, 0 0 0 4px #999, 0 2px 5px 4px rgba(0, 0, 0, .2);
        box-shadow: 0 0 0 3px #fff, 0 0 0 4px #999, 0 2px 5px 4px rgba(0, 0, 0, .2);
    }

    #toprow {
        background: #F2F3F4;
        /* height: 6vh; */
        margin-bottom: 10px;
        /* color: rgb(74, 33, 150); */
        line-height: 6vh;
        text-align: center;
    }

    /* Extra small devices (phones, less than 768px)
    @media (max-width:767px) {
        body {
            font-size: 2px;
        }
    } */



    .btn-space {
        margin-right: 50px
    }

    .styleowner {
        margin-left: 100px;
        margin-right: 10px
    }

    /* h5 {
      font-weight:bold;
  } */

    /* Small devices (landscape phones, 544px and up) */
    @media (min-width: 544px) {
        h1 {
            font-size: 1.5rem;
        }

        h2 {
            font-size: 1rem;
        }

        /*1rem = 16px*/
    }

    /* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
    @media (min-width: 768px) {
        h1 {
            font-size: 2rem;
        }

        h2 {
            font-size: 1.5rem;
        }

        /*1rem = 16px*/
    }

    /* Large devices (desktops, 992px and up) */
    @media (min-width: 992px) {
        h1 {
            font-size: 2.5rem;
        }

        h2 {
            font-size: 2rem;
        }

        /*1rem = 16px*/
    }

    /* Extra large devices (large desktops, 1200px and up) */
    @media (min-width: 1200px) {
        h1 {
            font-size: 3rem;
        }

        h2 {
            font-size: 2.5rem;
        }

        /*1rem = 16px*/
    }
</style>
<meta name="viewport" content="width=device-width, initial-scale=1.0">
<header id="top-section">
    <nav class="navbar navbar-expand-lg bg-dark navbar-dark navbar-static-top">
        <a class="navbar-brand" routerLink="/home">STREETSHOPS</a>
        <!-- Collapsible content -->

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar"
            (click)="toggleNavbar()">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{ 'show': navbarOpen }" id="collapsibleNavbar">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item">
                    <a class="nav-link" pageScroll routerLink="/home">Home</a>
                </li>
                <!-- <li class="nav-item">
                    <a class="nav-link" pageScroll routerLink="/favourites">Favourites</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" pageScroll routerLink="/shops">Shops</a>
                </li> -->
                <li class="nav-item">
                    <a class="nav-link active" pageScroll routerLink="/style">Style</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" pageScroll routerLink="/messages">Messages<span class="badge  ml-2"><i
                                class="far fa-envelope"></i></span><span class="badge badge-danger ml-1">1</span></a>
                </li>
            </ul>

            <ul class="navbar-nav ml-auto nav-flex-icons">
                <li class="nav-item">
                    <a class="nav-link" pageScroll routerLink="/collect">
                        Collect<span class="badge  ml-2"><i class="fas fa-tag"></i></span><span
                            class="badge badge-danger ml-1">{{collectItemsCount}}</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="checkAuth()" pageScroll routerLink="/wishlist">
                        <!-- <fa-icon [icon]='faHeart'></fa-icon> -->
                        Wishlist
                    </a>
                </li>
                <li class="nav-item dropdown btn-group dropleft" dropdown>
                    <a dropdownToggle type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect
                        (click)="checkAuth()">
                        Profile<span class="caret"></span></a>
                    <div *ngIf="auth.user$ | async as user">
                        <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
                            <a class="dropdown-item waves-light" href="#" mdbWavesEffect>Account</a>
                            <a class="dropdown-item waves-light" href="#" mdbWavesEffect>Subscriptions</a>
                            <a class="dropdown-item waves-light" href="#" mdbWavesEffect>Settings</a>
                            <div class="divider dropdown-divider"></div>
                            <a class="dropdown-item waves-light" (click)="auth.signOut()" mdbWavesEffect>Logout</a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</header>
<div class="mt-3"></div>
<!-- Nav tabs -->

<br>
<!--Section: Products v.3-->
<section class="section pb-3 wow fadeIn mb-5" data-wow-delay="0.3s">

    <div [ngSwitch]="'shared'">
        <div *ngSwitchCase="shared">
            <!-- code to render a large video block-->
            <button mdbBtn (click)="followStyle()" class="btn-space btn-rounded float-right" type="button"
                gradient="peach" size="lg" mdbWavesEffect>Follow <i class="fas fa-share"></i></button>
        </div>
        <div *ngSwitchDefault>
            <button mdbBtn cdkCopyToClipboard={{shortLink}} (click)="copyStyleLink()"
                class="btn-space btn-rounded float-right" type="button" gradient="peach" size="lg" mdbWavesEffect>Share
                <i class="fas fa-share"></i></button>
            <!-- <div class="styleowner">
            </div> -->
        </div>
    </div>

    <!-- <div *ngIf="showLink" class="mt-3 mb-3">
        <p>Share URL is: {{shortLink}}</p>
    </div> -->

    <!-- <button mdbBtn cdkCopyToClipboard={{shortLink}} (click)="copyStyleLink()" class="btn-space float-right"
            type="button" gradient="peach" size="lg" mdbWavesEffect>Share <i class="fas fa-share"></i></button>
        <div class="styleowner"> -->
    <div class="ml-5">
        <div class="avatar mx-auto white float-left"><img src="{{styleData.ownerAvatar}}" 
                class="rounded-circle img-fluid mr-5">
            <h6 class="mx-auto float-left mb-4" style="padding-top: 13%; padding-left: 3%; text-align: center;">
                <Strong>{{styleData.owner}}</Strong>
            </h6>
        </div>
    </div>
</section>

<section id="capture" style="padding-top: 12%;">
    <!--Section heading-->
    <br>
    <h2 class="text-center h2 ml-3 mr-3">{{styleData.stylename}}</h2>
    <h4 class="text-center grey-text pb-5">{{styleData.styleSummary}}</h4>

    <div class="card-deck ml-4 mr-4">
        <div *ngFor="let style of stylelistArray">
            <div class="card mt-3 view overlay zoom">
                <!-- <div class="card-body"> -->
                    <!-- delete -->
                    <!-- <div *ngIf="shared != 'shared'" class="form-check float-left mb-4">
                        <button mdbBtn color="alert" class="waves-light" type="button"
                            (click)="deleteProduct(style.productreference)" mdbWavesEffect>
                            <mdb-icon fas icon="trash-alt" class="mr-1"></mdb-icon>Delete
                        </button>
                    </div>
                    <br> -->
                    <!-- Background color -->
                    <div class="card-up indigo lighten-1"></div>

                    <div class="card-image mx-auto white mt-3"><img src='{{style.mainimage}}' 
                            class="img-fluid mb-2"
                            (click)="productSelected(style.retailerreference, style.productreference)">
                    </div>

                    <!--Card content-->
                    <div class="card-body">
                        <h4 class="card-title">{{style.productname}}</h4>
                        <h5>Price: {{style.productprice}}</h5>
                        <h5>{{style.retailername}}</h5>
                        <!-- <p class="card-text">{{style.productheader}}</p> -->
                    </div>
                    <div *ngIf="shared != 'shared'" class="card-footer">
                        <small class="text-muted">
                            <div class="form-check float-left mb-1">
                                <div *ngIf="shared != 'shared'" class="form-check float-left mb-1">
                                    <button mdbBtn color="alert" class="waves-light" type="button"
                                        (click)="deleteProduct(style.productreference)" mdbWavesEffect>
                                        <mdb-icon fas icon="trash-alt" class="mr-1"></mdb-icon>Delete
                                    </button>
                                </div>
                            </div>
                        </small>
                    </div>

                <!-- </div> -->
            </div>
        </div>
    </div>
</section>

 <!--Footer-->
 <footer class="page-footer text-center font-small mdb-color darken-2 mt-4 wow fadeIn">
    <hr class="my-4">
    
    <!--Copyright-->
    <div class=" footer-copyright py-3">
      © 2021 Copyright:
      <a href="https://smartcontx.com" target="_blank"> StreetShops Ltd </a>
    </div>
    <!--/.Copyright-->

  </footer>
  <!--/.Footer-->